export default __webpack_public_path__ + "static/Corprate_Careers-HQ_03-e5208e848b1b2cfeca25ed9ebde029df.jpg";